<template>
    <div>
        <div class="page-content">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-12">
                        <div class="card">
                            <div class="card-body">
                                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                                    <h4 class="mb-sm-0">{{this.label}} Data Transaksi Pengeluaran</h4>
                                    <div class="page-title-right">
                                        <ol class="breadcrumb m-0">
                                            <li class="breadcrumb-item"><router-link :to="{name : 'expenditure_transactions'}">Data Transaksi Pengeluaran</router-link></li>
                                            <li class="breadcrumb-item active">Form</li>
                                        </ol>
                                    </div>
                                </div>

                                <form v-on:submit.prevent="onSubmit">
                                    <div class="row">
                                        <input type="hidden" name="id" v-model="form.id">
                                        <div class="form-group col-md-6">
                                            <label>Nama</label>
                                            <input type="text" class="form-control"
                                                placeholder="Masukan data..." v-model="form.name" :class="{ 'is-invalid': submitted && $v.form.name.$error }">
                                            <div v-if="submitted && !$v.form.name.required" class="invalid-feedback">Nama Wajib diisi!</div>    
                                        </div>

                                        <div class="form-group col-md-6">
                                            <label>Jenis Pengeluaran</label>
                                            <v-select
                                                placeholder="Pilih Transaksi Pengeluaran"
                                                label="name"
                                                :options="dataExpenditureType"
                                                v-model="form.expenditure_type"
                                                :class="{ 'is-invalid': submitted && $v.form.expenditure_type.$error }"
                                                >                                    
                                            </v-select>

                                            <div v-if="submitted && !$v.form.expenditure_type.required" class="invalid-feedback" style="display:block !important"> Jenis Pengeluaran Wajib diisi!</div>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Total Pengeluaran</label>
                                            <input type="number" class="form-control"
                                                placeholder="Masukan data..." v-model="form.nominal" :class="{ 'is-invalid': submitted && $v.form.nominal.$error }" v-on:keyup="keyUpNominal">
                                            <div v-if="submitted && !$v.form.nominal.required" class="invalid-feedback">Total Pengeluaran Wajib diisi!</div>    
                                            <small v-if="form.nominal"><i>Keterangan: <b>{{this.form.text_nominal}}</b></i></small>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Tanggal</label>
                                            <datepicker v-model="form.expenditure_date" :input-class="{'form-control':true, 'is-invalid': submitted && $v.form.expenditure_date.$error }" :language="id" placeholder="Pilih Tanggal"></datepicker>
                                            <div v-if="submitted && !$v.form.expenditure_date.required" class="invalid-feedback" style="display:block !important"> Tanggal Sewa Wajib diisi!</div>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Keterangan</label>
                                            <textarea class="form-control" v-model="form.description" placeholder="Masukan data..." rows="4"></textarea>
                                        </div>

                                        <div class="form-group col-md-6 mt-3">
                                            <label>Unggah Berkas</label>
                                            <input type="file" class="form-control" name="attachment" id="attachment" @change="previewFiles" accept="application/pdf, image/png, image/gif, image/jpeg">
                                            <small v-if="form.previousAttachment" >File sebelumnya : <a :href="form.previousAttachment" target="blank">Lihat</a> </small>
                                        </div>
                                    </div>
                                    <div class="button-items mt-3">
                                        <button type="submit" class="btn btn-primary" :disabled="waiting">
                                        <i class="fa fa-save"></i> {{ waiting ? 'Harap tunggu ...' : 'Simpan' }}</button>
                                        <router-link :to="{name : 'expenditure_transactions'}" class="btn btn-outline-primary">Kembali</router-link>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {
        required
    } from "vuelidate/lib/validators";
    import Datepicker from 'vuejs-datepicker';
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";
    import {id} from 'vuejs-datepicker/dist/locale';
    import moment from 'moment';
    
    export default {
        name: 'ExpenditureTransactions',
        metaInfo: {
            title: 'Form Transaksi Pengeluaran',
            titleTemplate: '%s - Katarda'
        },
        components : {
            Datepicker,
            'v-select' : vSelect
        },
        created() {
            this.getType();
            this.getDataByID(this.$route.params.id);
        },
        data() {
            return {
                id : id,
                label           : 'Tambah',
                form : {
                    id                  : "",
                    expenditure_type    : [],
                    name                : "",
                    nominal             : 0,
                    text_nominal        : 0,
                    attachment          : "",
                    description         : "",
                    previousAttachment  : "",
                    expenditure_date    : moment().format('YYYY-MM-DD')
                },
                dataExpenditureType         : [],
                submitted       : false,
                waiting         : false
            }
        },
        validations: {
            form: {
                name: {
                    required
                },
                nominal: {
                    required
                },
                expenditure_type: {
                    required
                },
                expenditure_date: {
                    required
                }
            }
        },
        methods: {
            onSubmit: function () {
                this.waiting    = true;
                this.submitted  = true;

                // stop here if form is invalid
                this.$v.$touch();
                if (this.$v.$invalid) {
                    this.$swal({
                        icon: 'warning',
                        title: 'Ups!',
                        text: 'Harap lengkapi form',
                    });

                    this.waiting = false;
                    return;
                } else {    
                    let formData = new FormData();

                    formData.append('id', this.form.id);
                    formData.append('expenditure_type_id', this.form.expenditure_type.id);
                    formData.append('name', this.form.name);
                    formData.append('nominal', this.form.nominal);
                    formData.append('description', this.form.description);
                    formData.append('attachment', this.form.attachment);
                    formData.append('expenditure_date', this.convertDate(this.form.expenditure_date));

                    this.$http.post(process.env.VUE_APP_APIHOST + 'admin/expenditure_transactions/save', formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    })
                    .then(response => {
                            if (response.data.status) {
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                    confirmButtonText: 'OK'
                                }).then((result) => {
                                    if (result.value) {
                                        this.$router.push({ name: 'expenditure_transactions' });
                                    }
                                });
                            } else {
                                this.$swal({
                                    icon: 'warning',
                                    title: 'Ups!',
                                    text: response.data.message,
                                });
                            }
                            this.waiting = false;
                        })
                    .catch(function () {
                        this.$swal({
                            icon: 'warning',
                            title: 'Ups!',
                            text: 'Please check your internet connection.',
                        });
                        this.waiting = false;
                        return;
                    });

                }
            },
            getDataByID: function(id) {
                if (typeof (id) !== 'undefined' && id !== null) {
                    this.label  = "Ubah";

                    let uri     = process.env.VUE_APP_APIHOST+'admin/expenditure_transactions/detail';

                    this.dataFetch  = true;                
                    this.$http.get(uri,{
                        params : {
                            id : id
                        }
                    }).then(res => {
                        if(res.data.status) {
                            let getResponse = res.data.data;

                            this.form.id                    = getResponse.id;
                            this.form.name                  = getResponse.name;
                            this.form.nominal               = getResponse.nominal;
                            this.form.description           = getResponse.description;
                            this.form.expenditure_type      = getResponse.expenditure_type[0];
                            this.form.attachment            = getResponse.attachment;
                            this.form.previousAttachment    = getResponse.attachment;

                            if(this.form.nominal) {
                                this.form.text_nominal = this.rupiahFormat(this.form.nominal);
                            }                            
                        } else {
                            this.$swal({
                                icon: 'warning',
                                title: 'Ups!',
                                text: res.data.message,
                                confirmButtonText: 'OK'
                            }).then((result) => {
                                if (result.value) {
                                    this.$router.push({ name: 'expenditure_transactions' });
                                }
                            });
                        }
                    });
                }
            },
            getType: function() {
                let uri = process.env.VUE_APP_APIHOST+'admin/expenditure_transactions/expenditure_type_list';
                this.$http.get(uri).then(res => {
                    this.dataExpenditureType  = res.data.data;
                });
            },
            previewFiles(e) {
                const file = e.target.files[0];                
                var fsize = ((file.size/1024)/1024).toFixed(4); // MB
                
                if(fsize >= 5) {
                    alert("File yang di upload tidak boleh lebih 5 MB");
                } else {
                    this.form.attachment = file;
                }
            },
            convertDate : function (date) {
                return moment(date, 'YYYY-MM-DD').format('yyyy-MM-DD');
            },
            keyUpNominal: function() {
                if(this.form.nominal != '') {
                    this.form.text_nominal = this.rupiahFormat(this.form.nominal);
                } else {
                    this.form.text_nominal = this.rupiahFormat(0);
                }
            },
            rupiahFormat: function(nominal) {
                const numb      = nominal;
                const format    = numb.toString().split('').reverse().join('');
                const convert   = format.match(/\d{1,3}/g);
                const rupiah    = 'Rp. ' + convert.join('.').split('').reverse().join('')  

                return rupiah;              
            },
        }
    }
</script>